import React, { useState } from "react";
export default function NcbDiag() {
  const [out, setOut] = useState("");
  const log = (label, v) => setOut(p => p + `\n\n=== ${label} ===\n` + (typeof v === "string" ? v : JSON.stringify(v,null,2)));

  const ping = async () => {
    const base = window.__NCB_BASE__;
    log("NCB_BASE", base);
    const r = await fetch((base || "") + "/ping");
    log("PING status", r.status);
    log("PING body", await r.text());
  };
  const read = async () => {
    const base = window.__NCB_BASE__;
    const r = await fetch((base || "") + "/query", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action:"read", table:"prompt_templates_e4y8n3q5", limit:1 }),
    });
    log("READ status", r.status);
    log("READ body", await r.text());
  };
  return (
    <div style={{padding:16}}>
      <h1>NCB Diagnostics</h1>
      <button onClick={ping}>Ping</button>
      <button onClick={read} style={{marginLeft:8}}>Read</button>
      <pre style={{whiteSpace:"pre-wrap"}}>{out}</pre>
    </div>
  );
}